<template>
  <v-container fluid>
    <FormSubmitPopup
      :title="$t('splitOrder')"
      :value="show"
      :rightMethod="splitOrder"
      :rightButtonText="$t('submit')"
      :leftMethod="() => show = false"
      :rightButtonLoading="loading"
      hasAlert
      medium
    >
      <template v-slot:input>
        <Alert v-show="errorMessage" :text="errorMessage" />
        <template v-if="skuItems.length">
          <v-layout justify-space-between :key="index" v-for="(item, index) in skuItems">
            <v-flex md3>sku: {{ item.sku }}</v-flex>
            <v-flex md3>{{ $t('total') }}: {{ item.quantityPurchased - item.quantityShipped }}</v-flex>
            <v-flex md6></v-flex>
          </v-layout>
        </template>
        <v-layout v-if="order" style="margin-top: 10px;">
          <v-flex>
            <v-data-table
              :headers="headers"
              :items="orders"
              item-key="id"
              class="elevation-2 myDense"
              hide-actions
            >
              <template v-slot:items="props">
                <td class="text-xs-center">
                  <v-layout justify-center>
                    {{ $t('order') }} {{ props.index + 1 }}
                  </v-layout>
                </td>
                <td class="text-xs-center">
                  <v-layout align-center :key="j" v-for="(row, j) in props.item.items">
                    <v-flex>
                      {{ row.sku }}
                    </v-flex>
                    <v-flex>
                      <v-text-field
                        :label="$t('quantity')"
                        v-model.number="row.qty"
                        :rules="[
                          fieldIsRequired('quantity'),
                          fieldIsInteger('quantity')
                        ]"
                      ></v-text-field>
                    </v-flex>
                    <!-- <v-flex>
                      <v-btn
                        icon
                        flat
                        dark
                        color="primary"
                        @click.stop="deleteSku(props.item, j)"
                      >
                        <v-icon>delete</v-icon>
                      </v-btn>
                    </v-flex> -->
                  </v-layout>
                </td>
                <td class="text-xs-center">
                  <v-layout justify-center>
                    <v-btn
                      icon
                      flat
                      dark
                      color="primary"
                      v-if="order._key !== props.item.id"
                      @click.stop="deleteOrder(props.item, props.index)"
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </v-layout>
                </td>
              </template>
              <template v-slot:headers="props">
                <td class="text-xs-center">{{ $t('index') }}</td>
                <td class="text-xs-center">skus</td>
                <td class="text-xs-center">
                  <v-layout justify-center>
                    <v-btn
                      icon
                      flat
                      dark
                      color="primary"
                      @click.stop="addOrder(props.item)"
                    >
                      <v-icon>add</v-icon>
                    </v-btn>
                  </v-layout>
                </td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </template>
    </FormSubmitPopup>
  </v-container>
</template>

<script>
import FormSubmitPopup from './FormSubmitPopup'
import Alert from './Alert'
import { 
  checkRules,
  cloneDeep
} from '@/utils/tools'
export default {
  name: 'splitOrderPopup',
  components: {
    FormSubmitPopup,
    Alert
  },
  mixins: [
    checkRules
  ],
  data () {
    return {
      show: false,
      order: null,
      orders: [],
      errorMessage: '',
      loading: false
    }
  },
  computed: {
    headers () {
      const headers = [
        { text: this.$t('index'), value: 'index', align: 'center', sortable: false, width: '10%' },
        { text: 'skus', value: 'skus', align: 'center', sortable: false, width: '10%' },
        { text: this.$t('actions'), value: '', align: 'center', sortable: false, width: '10%' }
      ]
      return headers
    },
    skuItems () {
      return this.order?.items || []
    }
  },
  mounted () {

  },
  methods: {
    async splitOrder () {
      try {
        this.loading = true
        this.errorMessage = ''
        this.validSkus()
        const payload = this.getPayload()
        await this.$store.dispatch('splitOrder', payload)
        this.loading = false
        this.show = false
      } catch (err) {
        this.errorMessage = err.message
        this.loading = false
      }
    },
    showPopup (order) {
      const items = order.items.map(item => {
        const { quantityPurchased, quantityShipped, ...rest } = cloneDeep(item)
        rest.qty = quantityPurchased - quantityShipped
        return rest
      })
      this.errorMessage = ''
      this.order = order
      this.orders = [{ id: order._key, items }]
      this.show = true
    },
    deleteOrder (order, index) {
      const { id } = order
      if (this.order._key === id) return
      this.orders.splice(index, 1)
    },
    addOrder () {
      const items = this.skuItems.map(item => {
        const { quantityPurchased, quantityShipped, ...rest } = cloneDeep(item)
        rest.qty = 0
        return rest
      })
      const time = new Date().getTime()
      let key = this.order._key
      if (this.order.isSplitChildOrder) {
        key = `${this.order.platform}-${this.order.originOrderId}`
      }
      this.orders.push({ id: `${key}-${time}`, items, isSplitChildOrder: true })
    },
    validSkus () {
      const skusMap = this.orders.reduce((obj, item) => {
        const { items } = item
        items.forEach(row => {
          obj[row.sku] = (obj[row.sku] || 0) + row.qty
        })
        return obj
      }, {})
      if (this.orders.length <= 1) {
        throw Error(`order length must more than 1`)
      }
      const inValidSkuItems = this.skuItems.filter(item => {
        const { sku } = item
        return skusMap[sku] !== item.quantityPurchased - item.quantityShipped
      })
      if (inValidSkuItems.length) {
        const skus = inValidSkuItems.map(item => item.sku).join(',')
        throw Error(`sku ${skus} is not equal to the quantity`)
      }
    },
    getPayload () {
      return {
        orderKey: this.order._key,
        orders: this.orders.filter(order => {
          const { items } = order
          return items.some(item => +item.qty > 0)
        }).map(order => {
          const items = order.items.filter(item => +item.qty > 0)
          return { ...order, items }
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SplitOrderPopup.vue